namespace $.$$ {
	export class $shm_hitalama_map_widget_float_notebook extends $.$shm_hitalama_map_widget_float_notebook {
		
		@ $mol_mem
		widgets() {
			return this.widget().widgets()
		}
		
		@ $mol_mem
		items() {
			return this.widget().widgets().map( b => this.Item( b.link() ) )
		}

		@ $mol_mem_key
		widget_controls( ref: $giper_baza_link ): readonly ( any )[] {
			return [this.Map_page().Widget( ref ).Sub().Content_scroll()]
			// return this.Map_page().Widget( ref ).Sub().Content_scroll()
		}

		add_before( { before_link, type }: { before_link: $giper_baza_link, type: $shm_hitalama_map_widget_def_type_name } ) {

			const widget = this.map().widget_add( type, [Infinity, Infinity], 600, 300 )!
			widget.container_widget( this.widget() )
			// this.map().Widgets()?.cut( widget.link()! )

			const widgets = [...this.widget().widgets()]
			const pos = widgets.findIndex( b => b.link().toString() == before_link.toString() )

			widgets.splice( pos == -1 ? widgets.length : pos, 0, widget )
			this.widget().widgets( widgets )
		}

		widget_cut( ref: $giper_baza_link, next?: any ) {
			const widgets = [...this.widget().widgets()]
			this.widget().widgets( widgets.filter( b => b.link().toString() !== ref.toString() ) )
		}

		Add_widget_menu( before_link: $giper_baza_link ): $.$shm_hitalama_map_page_contextmenu {
			const obj = super.Add_widget_menu(before_link)
			obj.widget_add = ( type ) => {
				this.Add( before_link ).hovered( false )
				this.add_before( {before_link, type} )
			}
			return obj
		}
		
	}

	export class $shm_hitalama_map_widget_float_notebook_pop_over extends $.$shm_hitalama_map_widget_float_notebook_pop_over {
		
		showed() {
			return this.hovered()
		}
		
	}

}
